import CloseIcon from '@mui/icons-material/Close';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import FileUploadOutlinedIcon from "@mui/icons-material/FileUploadOutlined";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Backdrop,
  Button,
  CircularProgress,
  Grid,
  MenuItem,
  Select,
  TextField,
} from '@mui/material';
import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import { Box } from '@mui/system';
import { useFormik } from 'formik';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import * as Yup from "yup";
import pdfIcon from "../../../../images/pdfIcon.png";
import { AllPermissions } from '../../../../network/APIs/APIs';
import { cfpBaseUrl } from '../../../../network/urls';
import { allCFCLevelsAPI, handleFileUpload, isImage, isPdf } from '../../../../services/Functions';
import './RoleUpdateForm.scss';
import { documentExtensions } from '../../../../utils/PortalName';

const RoleUpdateForm = () => {
  const initialValues = {
    iv_roleName: "",
    iv_level: '',
    iv_status: '',
    iv_show_all_applications_flag: null,
    iv_assigning_order_no: '',
    iv_assigning_authority: '',
    iv_assigining_date: '',
    iv_assigining_order_image: ''
  };

  const [status, setStatus] = useState(1);
  const [applicationsAppliedLoadFilter, setApplicationsAppliedLoadFilter] = useState(0);
  const [sortedPermissions, setSortedPermissions] = useState([]);
  const [checkedItems, setCheckedItems] = useState([]);
  const [roleDataById, setRoleDataById] = useState();
  const [roleTypeId, setRoleTypeId] = useState('1');
  const [orderImage, setOrderImage] = useState();
  const [orderImageError, setOrderImageError] = useState();
  const [orderImageThumbnail, setOrderImageThumbnail] = useState();
  const [viewBackdrop, setViewBackdrop] = useState(false);
  const [cfcLevelList, setCFCLevelList] = useState([]);
  const [isLoadingSpinner, setIsLoadingSpinner] = useState(false);

  const { state } = useLocation();
  const { roleDetails } = state || {};
  const navigate = useNavigate();

  const { token, userId, permissions, hierarchy } = useSelector((state) => state.auth);

  const [technicalLevels, setTechnicalLevels] = useState([
    { value: 1, label: 'PITC' },
    { value: 2, label: 'DISCO' },
    { value: 3, label: 'Circle' },
    { value: 4, label: 'Division' },
    { value: 52, label: 'Sub Division' },
  ]);

  useEffect(() => {
    if (hierarchy != 1) {
      setTechnicalLevels((prev) =>
        prev.filter((item) => item.value >= parseInt(hierarchy, 10))
      );
    }
  }, [hierarchy]);

  useEffect(() => {
    if (roleDetails) {
      setRoleDataById(roleDetails);
      const typeId =
        roleDetails.roleTypeId != null
          ? String(roleDetails.roleTypeId)
          : roleDetails.roleTypeName === 'Technical'
            ? '2'
            : '1';
      setRoleTypeId(typeId);
    }
  }, [roleDetails]);

  useEffect(() => {
    const getAllPermissions = async () => {
      setViewBackdrop(true);
      const { sortedAllPermissions } = await AllPermissions(token, permissions);
      setSortedPermissions(sortedAllPermissions);
      setViewBackdrop(false);
    };
    getAllPermissions();
  }, [token, permissions]);

  useEffect(() => {
    const callCFCLevels = async () => {
      setViewBackdrop(true);
      let list = await allCFCLevelsAPI(token, cfpBaseUrl);
      if (list) {
        if (hierarchy != 1) {
          list = list.filter(
            (item) => parseInt(item.cfcLevelId, 10) >= parseInt(hierarchy, 10)
          );
        }
        setCFCLevelList(list);
      }
      setViewBackdrop(false);
    };
    callCFCLevels();
  }, [token, hierarchy]);

  const OrderImage = (event) => {
    if (event.target.files) {
      const newFileName =
        'orderImage.' + event.target.files[0].name.split('.').pop();
      handleFileUpload(
        event,
        handleChange,
        setOrderImage,
        setOrderImageError,
        setOrderImageThumbnail,
        newFileName
      );
    }
  };

  function base64toFile(base64String, filename) {
    const parts = base64String.split(';base64,');
    const type = parts[0].split(':')[1];
    const byteString = atob(parts[1]);
    const byteArray = new Uint8Array(byteString.length);
    for (let i = 0; i < byteString.length; i++) {
      byteArray[i] = byteString.charCodeAt(i);
    }
    const blob = new Blob([byteArray], { type });
    return new File([blob], filename, { type });
  }

  useEffect(() => {
    const getRoleDetails = async () => {
      if (!roleDataById) return;

      const rolesHeaders = new Headers();
      rolesHeaders.append("Authorization", token);
      const formdataRoles = new FormData();
      formdataRoles.append("roleId", roleDataById.id);
      const requestOptionsRoles = {
        method: "POST",
        headers: rolesHeaders,
        body: formdataRoles,
        redirect: "follow",
      };

      await fetch(cfpBaseUrl + "role/getLatestPremAsigningOrder", requestOptionsRoles)
        .then((response) => response.json())
        .then((result) => {
          if (result.status === '200' && result.data?.[0]) {
            values.iv_assigning_order_no = result.data[0].premAsigningOrderNo;
            values.iv_assigning_authority = result.data[0].premAsigningOrderAuthority;
            values.iv_assigining_date = result.data[0].premAsigningOrderDate.slice(0, 10);
            setOrderImageThumbnail(result.data[0].premAsigningOrderImage);
            setOrderImage(base64toFile(result.data[0].premAsigningOrderImage, 'order.png'));
          }
        })
        .catch((error) => console.error(error));

      values.iv_roleName = roleDataById.name;
      values.iv_level = roleDataById.level;
      values.iv_status = roleDataById.status;
      values.iv_show_all_applications_flag = roleDataById.showAllApplicationsFlag;

      setStatus(roleDataById.status);
      setApplicationsAppliedLoadFilter(roleDataById.showAllApplicationsFlag);

      const formdata = new FormData();
      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);
      formdata.append("roleId", roleDataById.id);
      const requestOptions = {
        method: 'POST',
        body: formdata,
        headers: myHeaders,
        redirect: 'follow',
      };

      fetch(cfpBaseUrl + "role/getPremRole", requestOptions)
        .then((response) => response.json())
        .then((result) => {
          if (result.status === "200") {
            const permissionsArray = result.data.map((item) => item.perm_id);
            setCheckedItems(permissionsArray);
          }
        })
        .catch((error) => console.log('error', error));
    };

    getRoleDetails();
  }, [roleDataById]);

  const { values, errors, touched, handleChange, handleBlur, handleSubmit } = useFormik({
    initialValues,
    validationSchema: Yup.object({
      iv_roleName: Yup.string()
        .required("Role name is required.")
        .min(3, `Name can't be less than 3 characters!`),
      iv_level: Yup.mixed().required("Role level is required."),
      iv_status: Yup.mixed().required("Role status is required."),
      iv_show_all_applications_flag: Yup.number().required('Show all applications is required.'),
      iv_assigning_order_no: Yup.string().required("Order No. is required."),
      iv_assigning_authority: Yup.string().required("Order authority is required."),
      iv_assigining_date: Yup.date()
        .required("Order date is required.")
        .max(new Date(), 'Order date must be in the past!'),
      iv_assigining_order_image: Yup.string().required('Upload order image.'),
    }),
    onSubmit: async () => {
      setIsLoadingSpinner(true);
      const formdata = new FormData();
      formdata.append("roleId", roleDataById.id);
      formdata.append("roleName", values.iv_roleName);
      formdata.append("level", values.iv_level);
      formdata.append("status", values.iv_status);
      formdata.append("updatedBy", userId);
      checkedItems.forEach((item) => {
        formdata.append("permissions", item);
      });
      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);
      formdata.append("showAllApplicationsFlag", values.iv_show_all_applications_flag);
      formdata.append("premAsigningOrderNo", values.iv_assigning_order_no);
      formdata.append("premAsigningOrderAuthority", values.iv_assigning_authority);
      formdata.append("premAsigningOrderDate", values.iv_assigining_date);
      formdata.append("premAsigningOrderImage", orderImageThumbnail);

      const requestOptions = {
        method: 'POST',
        body: formdata,
        headers: myHeaders,
        redirect: 'follow',
      };

      await fetch(cfpBaseUrl + "role/UpdateRole", requestOptions)
        .then((response) => response.json())
        .then((result) => {
          if (result.status === '200') {
            setIsLoadingSpinner(false);
            const refreshForm = new FormData();
            const refreshHeaders = new Headers();
            refreshHeaders.append("Authorization", token);
            fetch(cfpBaseUrl + "role/getAllRoles", {
              method: 'POST',
              body: refreshForm,
              headers: refreshHeaders,
              redirect: 'follow',
            })
              .then((response) => response.json())
              .then((refreshResult) => {
                if (refreshResult.status === "200") {
                  navigate('/role-management');
                }
              })
              .catch((error) => console.log('error', error));
          } else {
            setIsLoadingSpinner(false);
          }
        })
        .catch(() => {
          setIsLoadingSpinner(false);
        });
    },
  });

  function CheckboxItem({ item, onCheck, checkedItems: checked, isRoot }) {
    const { idt, name, children } = item;

    function handleCheck(event) {
      onCheck(item, event.target.checked);
    }

    const isChecked = checked.includes(idt);

    const checkboxRow = (
      <div className={`perm-row${isRoot ? ' perm-row-root' : ''}`}>
        <input type="checkbox" id={`perm-${idt}`} checked={isChecked} onChange={handleCheck} />
        <label htmlFor={`perm-${idt}`}>{name}</label>
      </div>
    );

    if (isRoot) {
      if (children && children.length > 0) {
        return (
          <Accordion
            className="perm-accordion"
            defaultExpanded
            disableGutters
            elevation={0}
            square
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon className="perm-expand-icon" />}
              className="perm-accordion-summary"
            >
              <span
                className="perm-summary-stop"
                onClick={(e) => e.stopPropagation()}
                onKeyDown={(e) => {
                  if (e.key === 'Enter' || e.key === ' ') e.stopPropagation();
                }}
              >
                {checkboxRow}
              </span>
            </AccordionSummary>
            <AccordionDetails className="perm-accordion-details">
              <div className="perm-children perm-children-under-accordion">
                {children.map((child) => (
                  <CheckboxItem
                    key={child.idt}
                    item={child}
                    onCheck={onCheck}
                    checkedItems={checked}
                  />
                ))}
              </div>
            </AccordionDetails>
          </Accordion>
        );
      }
      return <div className="perm-root perm-root-simple">{checkboxRow}</div>;
    }

    return (
      <>
        {checkboxRow}
        {children && children.length > 0 && (
          <div className="perm-children">
            {children.map((child) => (
              <CheckboxItem
                key={child.idt}
                item={child}
                onCheck={onCheck}
                checkedItems={checked}
              />
            ))}
          </div>
        )}
      </>
    );
  }

  function CheckboxHierarchy({ data }) {
    function handleCheck(item, isChecked) {
      let newCheckedItems = [...checkedItems];

      if (isChecked) {
        newCheckedItems.push(item.idt);
        checkChildrenAndGrandchildren(item, newCheckedItems);
      } else {
        newCheckedItems = uncheckChildrenAndGrandchildren(item, newCheckedItems);
        newCheckedItems = newCheckedItems.filter((checkedItem) => checkedItem !== item.idt);
      }
      setCheckedItems(newCheckedItems);
    }

    function checkChildrenAndGrandchildren(item, items) {
      if (item.children) {
        item.children.forEach((child) => {
          items.push(child.idt);
          checkChildrenAndGrandchildren(child, items);
        });
      }
    }

    function uncheckChildrenAndGrandchildren(item, items) {
      if (item.children) {
        item.children.forEach((child) => {
          items = uncheckChildrenAndGrandchildren(child, items);
          items = items.filter((checkedItem) => checkedItem !== child.idt);
        });
      }
      return items;
    }

    return (
      <div className="permissions-grid">
        {data.map((rootItem) => (
          <CheckboxItem
            key={rootItem.idt}
            item={rootItem}
            onCheck={handleCheck}
            checkedItems={checkedItems}
            isRoot
          />
        ))}
      </div>
    );
  }

  const Status = (event) => {
    setStatus(event.target.value);
    values.iv_status = event.target.value;
  };

  const ApplicationsAppliedLoadFilter = (event) => {
    setApplicationsAppliedLoadFilter(event.target.value);
    values.iv_show_all_applications_flag = event.target.value;
  };

  const todayMax = new Date().toISOString().split('T')[0];
  const roleTypeLabel =
    roleDataById?.roleTypeName ||
    (roleTypeId === '2' ? 'Technical' : 'Commercial');

  return (
    <>
      <Grid container className="roleUpdate">
        <Box className="roleUpdateContainer">
          <h3 className="heading">Role Update Form</h3>
          <form className="ncform">
            <div className="section-card section-card--accent">
              <div className="section-title">Basic Information</div>
              <Grid container>
                <Grid item xs={12} sm={6} md={3}>
                  <div className="field-wrap">
                    <label className="fieldLabel">Role Type</label>
                    <div className="field-readonly" aria-readonly="true">
                      {roleTypeLabel}
                    </div>
                  </div>
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                  <div className="field-wrap">
                    <label className="fieldLabel">Role Name</label>
                    <TextField
                      type="text"
                      name="iv_roleName"
                      autoComplete="off"
                      value={values.iv_roleName}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      id="iv_roleName"
                      className="textInputField"
                      placeholder="Enter role name"
                    />
                    <Box className="from-Error">
                      {errors.iv_roleName && touched.iv_roleName
                        ? errors.iv_roleName
                        : null}
                    </Box>
                  </div>
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                  <div className="field-wrap">
                    <label className="fieldLabel">Status</label>
                    <FormControl className="form-control">
                      <RadioGroup
                        className="radio-group"
                        row
                        name="iv_status"
                        value={status}
                        onChange={Status}
                      >
                        <FormControlLabel
                          value={1}
                          className="form-control-label"
                          control={<Radio />}
                          label="Active"
                          labelPlacement="end"
                        />
                        <FormControlLabel
                          value={2}
                          className="form-control-label"
                          control={<Radio />}
                          label="Inactive"
                          labelPlacement="end"
                        />
                      </RadioGroup>
                    </FormControl>
                  </div>
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                  <div className="field-wrap">
                    <label className="fieldLabel">Show All Applications</label>
                    <FormControl className="form-control">
                      <RadioGroup
                        className="radio-group"
                        row
                        name="iv_show_all_applications_flag"
                        value={applicationsAppliedLoadFilter}
                        onChange={ApplicationsAppliedLoadFilter}
                      >
                        <FormControlLabel
                          value={1}
                          className="form-control-label"
                          control={<Radio />}
                          label="Yes"
                          labelPlacement="end"
                        />
                        <FormControlLabel
                          value={0}
                          className="form-control-label"
                          control={<Radio />}
                          label="No"
                          labelPlacement="end"
                        />
                      </RadioGroup>
                    </FormControl>
                  </div>
                </Grid>

                {roleTypeId === '1' && (
                  <Grid item xs={12} sm={6} md={3}>
                    <div className="field-wrap">
                      <label className="fieldLabel">Level</label>
                      <Select
                        autoWidth={false}
                        value={values.iv_level}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        displayEmpty
                        name="iv_level"
                        size="small"
                        id="iv_level"
                        className="dropdownList"
                      >
                        <MenuItem value="">Select Level</MenuItem>
                        {cfcLevelList.map((item) => (
                          <MenuItem key={item.cfcLevelId} value={item.cfcLevelId}>
                            {item.cfcLevelName}
                          </MenuItem>
                        ))}
                      </Select>
                      <Box className="from-Error">
                        {errors.iv_level && touched.iv_level ? errors.iv_level : null}
                      </Box>
                    </div>
                  </Grid>
                )}
                {roleTypeId === '2' && (
                  <Grid item xs={12} sm={6} md={3}>
                    <div className="field-wrap">
                      <label className="fieldLabel">Level</label>
                      <Select
                        autoWidth={false}
                        value={values.iv_level}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        displayEmpty
                        name="iv_level"
                        size="small"
                        id="iv_level"
                        className="dropdownList"
                      >
                        <MenuItem value="">Select Level</MenuItem>
                        {technicalLevels.map((item) => (
                          <MenuItem key={item.value} value={item.value}>
                            {item.label}
                          </MenuItem>
                        ))}
                      </Select>
                      <Box className="from-Error">
                        {errors.iv_level && touched.iv_level ? errors.iv_level : null}
                      </Box>
                    </div>
                  </Grid>
                )}

                <Grid item xs={12} sm={6} md={3}>
                  <div className="field-wrap">
                    <label className="fieldLabel">Order No.</label>
                    <TextField
                      type="text"
                      name="iv_assigning_order_no"
                      autoComplete="off"
                      value={values.iv_assigning_order_no}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      id="iv_assigning_order_no"
                      className="textInputField"
                      placeholder="e.g. 1234"
                    />
                    <Box className="from-Error">
                      {errors.iv_assigning_order_no && touched.iv_assigning_order_no
                        ? errors.iv_assigning_order_no
                        : null}
                    </Box>
                  </div>
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                  <div className="field-wrap">
                    <label className="fieldLabel">Order Authority</label>
                    <TextField
                      type="text"
                      name="iv_assigning_authority"
                      autoComplete="off"
                      value={values.iv_assigning_authority}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      id="iv_assigning_authority"
                      className="textInputField"
                      placeholder="Enter authority name"
                    />
                    <Box className="from-Error">
                      {errors.iv_assigning_authority && touched.iv_assigning_authority
                        ? errors.iv_assigning_authority
                        : null}
                    </Box>
                  </div>
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                  <div className="field-wrap">
                    <label className="fieldLabel">Order Date</label>
                    <input
                      type="date"
                      name="iv_assigining_date"
                      value={values.iv_assigining_date}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      id="iv_assigining_date"
                      className="dateInputField"
                      max={todayMax}
                    />
                    <Box className="from-Error">
                      {errors.iv_assigining_date && touched.iv_assigining_date
                        ? errors.iv_assigining_date
                        : null}
                    </Box>
                  </div>
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                  <div className="field-wrap">
                    <label className="fieldLabel">Order Image</label>
                    <div className="upload-wrap">
                      {orderImage ? (
                        <Button
                          component="label"
                          startIcon={
                            <CloseIcon
                              className="button-with-image"
                              onClick={() => {
                                setOrderImage("");
                              }}
                            />
                          }
                        >
                          {orderImageThumbnail && isImage(orderImage) ? (
                            <div className="btn-div">
                              <img
                                src={orderImageThumbnail}
                                alt="Order attachment preview"
                                width="80"
                              />
                            </div>
                          ) : (
                            <span>
                              {isPdf(orderImage) ? (
                                <div className="btn-div">
                                  <img src={pdfIcon} alt="PDF" width="80" />
                                </div>
                              ) : (
                                "Other file type"
                              )}
                            </span>
                          )}
                        </Button>
                      ) : (
                        <>
                          <Button
                            variant="outlined"
                            component="label"
                            startIcon={<FileUploadOutlinedIcon />}
                            className="btn"
                          >
                            Upload
                            <input
                              hidden
                              accept={documentExtensions}
                              id="iv_assigining_order_image"
                              name="iv_assigining_order_image"
                              type="file"
                              onChange={OrderImage}
                            />
                          </Button>
                          <Box className="from-Error">
                            {orderImage === '' ? orderImageError : null}
                          </Box>
                        </>
                      )}
                    </div>
                    <Box className="from-Error">
                      {errors.iv_assigining_order_image && touched.iv_assigining_order_image
                        ? errors.iv_assigining_order_image
                        : null}
                    </Box>
                  </div>
                </Grid>
              </Grid>
            </div>

            <div className="section-card permissions-wrap">
              <div className="section-title-row">
                <div>
                  <div className="section-title">Permissions</div>
                  <p className="section-subtitle">
                    Expand or collapse each module to work through nested permissions. Sections start open so nothing is hidden by default.
                  </p>
                </div>
                <span className="perm-selected-pill" aria-live="polite">
                  {checkedItems.length} selected
                </span>
              </div>
              <CheckboxHierarchy data={sortedPermissions} />
            </div>

            <Box className="submit-area">
              <Button
                className="submit-btn"
                variant="contained"
                size="medium"
                onClick={handleSubmit}
                disabled={isLoadingSpinner}
              >
                {isLoadingSpinner ? (
                  <Box sx={{ display: 'flex' }}>
                    <CircularProgress size={22} sx={{ color: '#fff' }} />
                  </Box>
                ) : (
                  'Update'
                )}
              </Button>
            </Box>
          </form>
        </Box>
      </Grid>

      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1000 }}
        open={viewBackdrop}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </>
  );
};

export default RoleUpdateForm;
